import { Subscription } from "@/@types/subscriptions";

export function mergeSubscriptions(
  subscriptions: Subscription[],
  metaList: Partial<Subscription>[],
  availableIds?: string | null,
): Subscription[] {
  const metaMap = new Map<number, Partial<Subscription>>();
  const availableIdsList = availableIds?.split(",").map((id) => parseInt(id.trim(), 10));

  for (const meta of metaList) {
    if (meta.subscription !== undefined) {
      metaMap.set(meta.subscription, meta);
    }
  }

  if (availableIdsList) {
    subscriptions = subscriptions.filter((sub) => availableIdsList?.includes(sub.id));
  }

  return subscriptions.map((sub) => {
    const meta = metaMap.get(sub.id);
    if (meta) {
      return {
        ...sub,
        date_of_debiting: meta.date_of_debiting,
        auto_payment: meta.auto_payment,
        subscription: meta.subscription,
      };
    }
    return sub;
  });
}

export function filterAndMergeSubscriptions(
  subscriptions: Subscription[],
  metaList: Partial<Subscription>[],
): Subscription[] {
  const metaMap = new Map<number, Partial<Subscription>>();

  for (const meta of metaList) {
    if (meta.subscription !== undefined) {
      metaMap.set(meta.subscription, meta);
    }
  }

  return subscriptions
    .filter((sub) => metaMap.has(sub.id))
    .map((sub) => {
      const meta = metaMap.get(sub.id)!;
      return {
        ...sub,
        date_of_debiting: meta.date_of_debiting,
        auto_payment: meta.auto_payment,
        subscription: meta.subscription,
      };
    });
}
